export default __webpack_public_path__ + "static/media/f-herramientas.9af010e1.png";